import {Component} from '@angular/core';
import {EnvService} from "../services/env.service";
import {HttpClient} from "@angular/common/http";
import {BaseComponent} from "../base/base.component";
import { ActivatedRoute, Router, Params } from '@angular/router';
import {AlertService} from "../services/alert.service";
import {AuthService} from "../services/auth.service";

@Component({
  selector: 'micro-remedyConfig-detail',
  templateUrl: './remedyConfig-detail.component.html'
})
export class RemedyConfigDetailComponent extends BaseComponent {
  companyId:any;
  remedyConfig:any;
  testResult:any;

  constructor(protected env: EnvService,
              protected http: HttpClient,
              private route: ActivatedRoute,
              private router:Router,
              private authService:AuthService,
              private alertService:AlertService) {
    super(env, http);
  }

  protected onInit(): void {
    this.route.params
      .subscribe((params: Params) => {
        let id:any = params['id'];
        if (id === '0') {
          this.createNew();
        } else {
          this.http.get(`${this.env.e.url}/remedy/configs/${id}`).subscribe(
            data => {
              this.remedyConfig = data as any;
              if (this.remedyConfig.company) {
                this.companyId = this.remedyConfig.company.id;
              }
              this.testConnection();
            }
          );
        }
      });
  }

  createNew() {
    this.companyId = this.authService.getCompanyId();
    this.remedyConfig = {
      port: 36000,
      timeout: 10000
    };
  }

  save() {
    if (this.companyId && this.companyId !== '') {
      this.remedyConfig.company = {
        id: this.companyId
      }
    }

    if (!this.remedyConfig.id) {
      this.http.post(`${this.env.e.url}/remedy/configs`, this.remedyConfig)
        .subscribe(
          data => {
            this.remedyConfig = data;
            this.alertService.info(`Created ${this.remedyConfig.name}`);
            this.testConnection();
          }
        );
    } else {
      this.http.put(`${this.env.e.url}/remedy/configs/${this.remedyConfig.id}`, this.remedyConfig)
        .subscribe(
          data => {
            this.remedyConfig = data;
            this.alertService.info(`Updated connection settings`);
            this.testConnection();
          }
        );
    }
  }

  delete() {
    this.http.delete(`${this.env.e.url}/remedy/configs/${this.remedyConfig.id}`)
      .subscribe(
        complete => {
          this.alertService.info(`Deleted Mailbox ${this.remedyConfig.name}`);
          this.router.navigate(["/remedy/configs"]);
        }
      );
  }


  hasRole(role:string) {
    if (!role) {
      return true;
    }
    return this.authService.hasRole(role);
  }

  testConnection() {
    this.testResult = null;
    this.http.get(`${this.env.e.url}/remedy/configs/${this.remedyConfig.id}/test`).subscribe(
      data => {
        this.testResult = data as any;
      }
    );
  }
}
